import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';

export default pagingMaker({
  fetchType: actions.JOURNAL_ENTRIES_FETCH,
  fetchSuccessType: actions.JOURNAL_ENTRIES_FETCH_SUCCESS,
  fetchErrorType: actions.JOURNAL_ENTRIES_FETCH_ERROR,
  possiblePageUpdateType: actions.JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/paging/reducer.js
 **/